<template>
  <div class="DarkWhite pa-4 ">
      <h2 class="subheading green--text">Delivery Term</h2>
      <v-card class="mt-4">
      <PSUDeliveryTermUtility/>
  </v-card>
  </div>
</template>

<script>
import PSUDeliveryTermUtility from '../components/Utils/PSUDeliveryTermUtility.vue'
  export default {
    components: {
      PSUDeliveryTermUtility
    },
    data: () => ({
    }),
  }
</script>


<style scoped>
</style>